import type { CatalogItem } from '@/entities/catalog-item';
import { isRecentlyLaunched } from '@/entities/catalog-item';
import type { SymbolKey } from '@/entities/symbol';

import type { FilterFn, Row } from '@tanstack/react-table';

export const arrEqualsSome: FilterFn<CatalogItem> = (
  row: Row<CatalogItem>,
  columnId: string,
  filterValue: string[]
) => {
  if (!filterValue.length) return true;
  const value: string | undefined = row.getValue(columnId);
  if (typeof value !== 'string') return false;
  return filterValue.some(
    selectedFilterValue => value.toLocaleLowerCase() === selectedFilterValue.toLocaleLowerCase()
  );
};
export const filterByStatus: FilterFn<CatalogItem> = (
  row: Row<CatalogItem>,
  columnId: string,
  filterValue: boolean
) => {
  if (filterValue) {
    return true;
  }
  const value = row.getValue(columnId);
  return value !== 'Archive';
};

export const filterByNewData: FilterFn<CatalogItem> = (
  row: Row<CatalogItem>,
  columnId: string,
  filterValue: boolean
) => {
  if (!filterValue) return true;
  return isRecentlyLaunched(row.getValue<string | undefined>(columnId), new Date());
};

export const filterBySelectedCode: FilterFn<CatalogItem> = (
  row: Row<CatalogItem>,
  columnId: string,
  filterValue: SymbolKey[]
) => {
  if (!filterValue.length) return true;
  return filterValue.some(selectedSymbol => {
    const symbol = {
      Code: row.getValue('Code'),
      Period: row.getValue('Period'),
      PeriodType: row.getValue('PeriodType'),
      TimeRef: row.getValue('TimeRef')
    };

    return (
      symbol.Code === selectedSymbol.Code &&
      symbol.Period === selectedSymbol.Period &&
      symbol.PeriodType === selectedSymbol.PeriodType &&
      symbol.TimeRef === selectedSymbol.TimeRef
    );
  });
};

export const filterBySelectedCurve: FilterFn<CatalogItem> = (
  row: Row<CatalogItem>,
  columnId: string,
  filterValue: SymbolKey[]
) => {
  if (!filterValue.length) return true;
  const rowCode = row.getValue<string | undefined>('Code');
  const rowPeriodType = row.getValue<string | undefined>('PeriodType');
  const rowTimeRef = row.getValue<string | undefined>('TimeRef');
  return filterValue.some(
    selectedSymbol =>
      rowCode === selectedSymbol.Code &&
      rowPeriodType === selectedSymbol.PeriodType &&
      rowTimeRef === selectedSymbol.TimeRef
  );
};
